module.exports = __webpack_public_path__ + "static/media/bookmark-active.12d2da17.svg";